import { Stack, Typography } from "@mui/material";

import { OpenInNewOutlinedIcon as OpenInNewOutlined } from "@/icons";
import { MuiButton } from "@/orion/MuiComponents/MuiButton";
import {
  ORION_BORDER_CARD_IMAGE_URLS,
  OrionBorderCard,
} from "@/orion/OrionComponents/OrionBorderCard";

export type SKUStorePrepareMediaBannerProps = {
  collectionName: string;
  productCount?: number;
  /** Opens the CreativeSphere pilot flow scoped to this collection/category. */
  onOpen?: () => void;
};

/**
 * "Prepare media for this collection" entry point. Uses the same
 * {@link OrionBorderCard} outline + background as the CreativeSphere grid
 * banner, with just the heading/description and the CreativeSphere CTA.
 */
export function SKUStorePrepareMediaBanner({
  collectionName,
  productCount,
  onOpen,
}: SKUStorePrepareMediaBannerProps) {
  const countPart =
    productCount === undefined ? "" : ` ${String(productCount)}`;

  return (
    <OrionBorderCard
      backgroundImage={ORION_BORDER_CARD_IMAGE_URLS.multiColorAbstractHex}
      borderRadius={3}
      padding={3}
      innerBorderRadius={2}
      innerSx={{ p: 6 }}
      sx={{ mb: 5 }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={4}
      >
        <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h4"
            component="h4"
            sx={{
              m: 0,
              color: "text.primary",
            }}
          >
            Prepare media for this collection
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "text.primary", maxWidth: 500 }}
          >
            {`Generate, review, and ready images and motion assets for all${countPart} products in ${collectionName}.`}
          </Typography>
        </Stack>
        <MuiButton
          variant="contained"
          onClick={onOpen}
          endIcon={<OpenInNewOutlined aria-hidden fontSize="small" />}
          sx={{
            flexShrink: 0,
            borderRadius: 999,
            px: 6,
            textTransform: "uppercase",
            letterSpacing: "0.17px",
            backgroundColor: "#7700ee",
            "&:hover": { backgroundColor: "#6300cc" },
          }}
        >
          Open in CreativeSphere
        </MuiButton>
      </Stack>
    </OrionBorderCard>
  );
}
